/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { defineStore } from 'pinia';

import { useRootStore } from './root';

import {
  BulkImportRepository,
  BulkImportReserveForm,
} from '@/repositories/generated';

type BulkImportState = {
  form?: BulkImportReserveForm;
  badRequestError?: {
    error: {
      code: string;
      message: string;
    };
  };
};

export const useBulkImportStore = defineStore('bulkImport', {
  state: (): BulkImportState => ({
    form: undefined,
    badRequestError: undefined,
  }),
  actions: {
    /** フォーム用のフォーマットからapi用のフォーマットに変換してSet */
    setUiForm(form: BulkImportReserveForm) {
      this.form = {
        ...form,
      };
    },
    getBadRequestErrorAndDeleteStore() {
      const { badRequestError } = this;
      this.badRequestError = undefined;
      return badRequestError;
    },
    async bulkImport(requestBody: BulkImportReserveForm) {
      const rootStore = useRootStore();
      rootStore.isLoading = true;

      return BulkImportRepository.reserve({ requestBody })

        .finally(() => {
          rootStore.isLoading = false;
        });
    },
  },
  getters: {},
});
